export const AdminFeatures = [
    "manage_all_workspaces",
    "workspace_manager"
  ];
  
  export const UsersFeatures = [
    "get_reports"
  ];

  export const SystemAdminWorkspacePermission = "manage_all_workspaces";

  export const ApplicationLevelAdminWorkspacePermission = "workspace_manager";